import React, { useState, useEffect } from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
  TablePagination,
} from '@mui/material'
import ErrorMessage from '../../component/shared/component/ErrorMessage'
import { useGetCompanyMappings, usePostCompanyMapping } from '../../api/company-mapping'
import Row from './Row'
import Form from './Form'
import { LoadingSkeletonRows } from '../shared/LoadingSkeletonRows'

const Table = ({ open, setOpen, searchKey }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const {
    data = {},
    isLoading,
    refetch,
  } = useGetCompanyMappings({ page: page + 1, limit: rowsPerPage, ...(searchKey && { searchKey }) })

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  useEffect(() => {
    setPage(0)
  }, [searchKey])

  return (
    <Box>
      {data.docs?.length > 0 || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell>Company Name</TableCell>
                  <TableCell>EKT ID</TableCell>
                  <TableCell>HWT ID</TableCell>
                  <TableCell>HTE ID</TableCell>
                  <TableCell>HTL ID</TableCell>
                  <TableCell>HTB ID</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={6} />
                ) : (
                  data.docs.map((row) => <Row data={row} key={row.id} refetch={refetch} />)
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
          {!isLoading && (
            <TablePagination
              component='div'
              count={data.totalDocs || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      ) : (
        <ErrorMessage empty />
      )}
      <Form
        defaultValues={{}}
        open={open}
        setOpen={setOpen}
        api={usePostCompanyMapping}
        refetch={refetch}
      />
    </Box>
  )
}

export default Table
